import React, {FC, useMemo} from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {CardImageContainer, IconWrapper, Image} from "./styled"

interface Props {
  url?: string
  type?: "square" | "circle"
  productBadge?: string
}

const CardImage: FC<Props> = ({url, type, productBadge}) => {
  const icon = useMemo(() => {
    switch (productBadge) {
      case "perks":
        return IconTypes.circlePerks
      case "celebration":
        return IconTypes.circleCelebration
      case "warning":
        return IconTypes.warning
      case "wellness":
        return IconTypes.circleWellness
      case "reward":
        return IconTypes.circleRewards
      case "admin":
        return IconTypes.circleAdmin
      default:
        return null
    }
  }, [productBadge])

  return (
    <CardImageContainer>
      <Image src={url} isSquare={type === "square"} />
      <IconWrapper>{icon && <Icon icon={icon} size={32} />}</IconWrapper>
    </CardImageContainer>
  )
}

export default CardImage
